exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img.qrcode-img[data-v-306cfb4d] {\n  display: block;\n  max-width: 100%;\n}\n@media (max-width: 600px) {\nimg.qrcode-img[data-v-306cfb4d] {\n      max-width: 300px;\n}\n}\n@media (max-width: 400px) {\nimg.qrcode-img[data-v-306cfb4d] {\n      max-width: 200px;\n}\n}\n@media (max-width: 400px) {\n.download-btn-holder[data-v-306cfb4d] {\n    display: none;\n}\n}\n", ""]);

// exports
